import { NotFound } from './src/NotFound.js';

export { NotFound } from './src/NotFound.js';

customElements.define("not-found",NotFound);